
import type React from "react";
import { type AppButtonProps } from "site/ui";
import { create } from "zustand";

type IInputPick = "width"|"isClosable"| "cancelText"|"okText"|"title"|"content"|"onCancel"|"onOk"|"containerStyle"|"okButtonProps"|"cancelButtonProps";
type IInput<T = any> = Partial<Pick<IModalStore<T>, IInputPick>>
export interface IModalStore<T = any> {
    isOpen: boolean;
    width?: number;
    isClosable?: boolean;
    title?: React.ReactNode;
    content: React.ReactNode | ((memory: any) => React.ReactNode);
    okText?: string;
    cancelText?: string;
    containerStyle?: React.CSSProperties;
    okButtonProps?: AppButtonProps;
    cancelButtonProps?: AppButtonProps;
    setOkButtonProps: (props: AppButtonProps) => void;
    openModal: (data: IInput<T>) => void;
    closeModal: () => void;
    onOk?: () => Promise<void>;
    onCancel?: () => Promise<void>;
    replaceInfo: (data: IInput<T>) => void;
    memory: any;
    setMemory: (data: Partial<T>) => void;
    getMemory: () => T;
}

const defaultModal: Omit<IModalStore, "openModal" | "closeModal" | "replaceInfo" | "setMemory" | "getMemory"|"setOkButtonProps"> = {
    isOpen: false,
    isClosable: false,
    title: "",
    content: "",
    okText: "OK",
    cancelText: "Cancel",
    cancelButtonProps: undefined,
    onOk: undefined,
    onCancel: undefined,
    containerStyle: {},
    memory: {} as any,
    width: 520,
};

export type IOpenParameters<T> = IInput<T> 

export const modalStore = create<IModalStore>((set, get) => ({
    ...defaultModal,
    setOkButtonProps: (props) => set({ okButtonProps: props }),
    replaceInfo: (data) => set(data),
    openModal: (data) => set({ ...data, isOpen: true }),
    closeModal: () => set(defaultModal),
    setMemory: (memory) => set({ memory: {...get().memory, ...memory } }),
    getMemory: () => {
        const { memory } = get();
        return memory
    }
}))
